import { Check } from '@timelyapp/icons/line-icons';
import { Dropdown } from '@timelyapp/react';
import { palettes } from 'constants/colorPalette';
import { useState } from 'react';
import { isContrastReadable } from 'utils/colors';
import styles from './AgentProjectPopover.module.scss';

export function AgentProjectColorPicker({
  color,
  clientColor,
  disabled,
  onChange,
}: {
  color: string | null;
  clientColor?: string;
  disabled: boolean;
  onChange: (color: string | null) => void;
}) {
  const [open, setOpen] = useState(false);
  const effectiveColor = color ?? clientColor ?? palettes[0][0];
  const choose = (value: string | null) => {
    onChange(value);
    setOpen(false);
  };
  return (
    <div className={styles.colorField}>
      <span>Color</span>
      <Dropdown
        open={open}
        onOpenChange={setOpen}
        side="bottom"
        align="end"
        showArrow={false}
        className={styles.colorSurface}
        aria-label="Project color"
        trigger={
          <button
            type="button"
            className={styles.colorTrigger}
            disabled={disabled}
            aria-label={
              color === null ? 'Project color: use client color' : `Project color: #${color}`
            }
          >
            <span style={{ backgroundColor: `#${effectiveColor.replace(/^#/, '')}` }} />
          </button>
        }
      >
        <div className={styles.colorPalette} aria-label="Project colors">
          {palettes.flat().map(value => (
            <button
              key={value}
              type="button"
              aria-label={`Color #${value}`}
              aria-pressed={color === value}
              style={{
                backgroundColor: `#${value}`,
                color: isContrastReadable('#fff', `#${value}`) ? '#fff' : '#343a3f',
              }}
              onClick={() => choose(value)}
            >
              {color === value && <Check width={16} height={16} aria-hidden="true" />}
            </button>
          ))}
        </div>
        <button
          type="button"
          className={styles.useClientColor}
          aria-pressed={color === null}
          onClick={() => choose(null)}
        >
          <span
            className={styles.colorSample}
            style={{
              backgroundColor: clientColor ? `#${clientColor.replace(/^#/, '')}` : undefined,
            }}
          />
          Use client color
          {color === null && <Check width={16} height={16} aria-hidden="true" />}
        </button>
      </Dropdown>
    </div>
  );
}
